import { render, staticRenderFns } from "./TestimonialBongo.vue?vue&type=template&id=1af50ff7&scoped=true&"
import script from "./TestimonialBongo.vue?vue&type=script&lang=js&"
export * from "./TestimonialBongo.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialBongo.vue?vue&type=style&index=0&id=1af50ff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af50ff7",
  null
  
)

export default component.exports